module.exports = __webpack_public_path__ + "static/LAC-e33c1b8773c92a197ea13a81295c84ee.png";